<template>
  <v-container fluid fill-height>
    <v-snackbar v-model="snackbar" :right="right" :timeout="timeout" :top="top">
      {{ message }}
      <v-btn @click="snackbar = false" color="pink" text>Close</v-btn>
    </v-snackbar>

    <!-- Recover Data -->
    <v-dialog justify="center" v-model="dialog" width="400">
      <v-card justify="center">
        <v-card-title
          aling="center"
          class="headline grey lighten-2"
          primary-title
        >Recuperar la contraseña</v-card-title>

        <v-divider></v-divider>

        <v-text-field v-model="email" solo label="Email" required />

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" color="primary" text>Cerrar</v-btn>
          <v-btn @click="recover" text color="success">Reestablecer</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- The rest of the code-->

    <v-row no-gutters align="center" aling-content="center" justify="center">
      <v-col cols="12" md="6" order="2" class="font-weight-light">
        <v-container fluid>
          <v-card
            ref="form"
            align="center"
            justify="center"
            width="950"
            class="title font-weight-light"
          >
            <v-card-text>
              <v-text-field
                ref="email"
                v-model="email"
                :rules="[() => !!email || 'Este campo es requerido']"
                label="Email *"
                required
              />

              <v-text-field
                ref="password"
                v-model="password"
                :rules="[
                  () => !!password || 'Este campo es requerido',
                  () =>
                    (!!password &&
                      password.length >= 8 &&
                      password.length <= 12) ||
                    'Contrasena debe ser mayor a 8 caracteres o menor a 12 '
                ]"
                :append-icon="show1 ? 'mdi-account' : 'mdi-account-outline'"
                :type="show1 ? 'text' : 'password'"
                label="Contraseña *"
                counter="12"
                required
              />
            </v-card-text>

            <v-card-actions>
              <v-btn @click="auth_login" block rounded color="light-blue" class="white--text">Login</v-btn>
            </v-card-actions>
            <v-divider class="mt-4"></v-divider>

            <v-card-actions>
              <v-btn
                @click="google_login"
                block
                rounded
                outlined
                color="accent"
                text
              >Inicia con Google</v-btn>
            </v-card-actions>

            <v-card-actions>
              <v-btn
                @click="orcid_login"
                block
                rounded
                outlined
                color="primary"
                text
              >Inicia con ORCID</v-btn>
            </v-card-actions>

            <v-divider class="mt-4"></v-divider>
            <v-card-actions>
              <v-row justify="center">
                <v-col justify="center" xs-12>
                  <v-btn @click="dialog = true" block color="accent" text>Recuperar Contraseña</v-btn>
                </v-col>
                <v-col xs-12>
                  <v-btn @click="create_account" block color="accent" text>Registrarme</v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>
          <v-alert
            v-model="alert"
            dismissible
            type="error"
          >El usuario o la contraseña ingresados no son correctos</v-alert>
        </v-container>
      </v-col>
    </v-row>
    <v-snackbar v-model="snackbarUser" :timeout="10000" :top="true">
      {{ messageUser }}
    </v-snackbar>
    <v-dialog v-model="dialogPwd" persistent max-width="400px">
      <v-card>
        <v-card-title>
          <span class="headline">Ingresa tu contraseña</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="providedPassword"
                  label="Contraseña*"
                  type="password"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>

          <small>*Campo requerido</small>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" text @click="dialogPwd = false">Cerrar</v-btn>

          <v-btn color="blue darken-1" text @click="logWithORCID()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import * as firebase from "firebase";
import axios from "axios";
import { orcidRedirectUri } from "../../main";
// import xmlParser from "xml2js";

export default {
  data() {
    return {
      dialogPwd: false,
      providedPassword: "",
      email: "",
      password: "",
      show1: false,
      alert: false,
      dialog: false,
      message: "Mensaje enviado con exito",
      snackbar: false,
      snackbarUser: false,
      messageUser: "",
      top: true,
      right: true,
      timeout: 4000,
      orcidUser: null
    };
  },

  async created() {
    const orcidCode = this.$route.query.code;
    const _this = this;
    // eslint-disable-next-line no-console
    console.log(orcidCode);

    if (!orcidCode) {
      //no existe el codigo por ende estoy sin orcid y procedo normal con otros metodos de login
    } else {
      // eslint-disable-next-line no-console
      console.log("intercambio de tocken");

      var body = new URLSearchParams();

      body.append("client_id", "APP-6T2U5INEDICQNRFN");
      body.append("client_secret", "aa4a4568-8134-4af9-bb82-8fa717ea577c");
      body.append("grant_type", "authorization_code");
      body.append("code", orcidCode);
      body.append("redirect_uri", orcidRedirectUri + "/login");

      axios
        .post(
          "https://cors-anywhere.herokuapp.com/https://orcid.org/oauth/token",
          body
        )
        .then(response => {
          this.messageUser = "Redirigiendo...";
          this.snackbarUser = true;
          // eslint-disable-next-line no-console
          console.log("respuesta" + JSON.stringify(response));

          var userTocken = response.data.access_token;

          // eslint-disable-next-line no-console
          console.log("ORCID Tocken: " + userTocken);
          var flag = 0;
          var user;
          var orcidId = response.data.orcid;
          // eslint-disable-next-line no-console
          console.log("ORCID-iD: " + orcidId);
          firebase
            .firestore()
            .collection("User")
            .where("orcid_id", "==", orcidId)
            .get()
            .then(function(querySnapshot) {
              querySnapshot.forEach(function(doc) {
                user = doc.data();
                user.id = doc.id;
                flag++;
              });
            })
            .catch(err => {
              //eslint-disable-next-line no-console
              console.log("Error: ", err);
            })
            .finally(() => {
              if (flag == 0) {
                //eslint-disable-next-line no-console
                console.log("ORCID-iD UNA LÍNEA ANTES DEL PUSH: " + orcidId);

                _this.$router.push({
                  name: "orcidRegistration",
                  params: { orcid_id: orcidId }
                });
              } else if (flag == 1) {
                // eslint-disable-next-line no-console
                console.log(user);
                var pswd = localStorage.getItem('pswd');
                // eslint-disable-next-line no-console
                console.log("Password: " + pswd);
                if (pswd) {
                  var CryptoJS = require("crypto-js");
                  const hash = CryptoJS.SHA3("participainteligente").toString();
                  const bytes = CryptoJS.AES.decrypt(pswd, hash);
                  const original = bytes.toString(CryptoJS.enc.Utf8);
                  // eslint-disable-next-line no-console
                  console.log(original);
                  firebase
                    .auth()
                    .signInWithEmailAndPassword(user.email.primary, original)
                    .then(user => {
                      // eslint-disable-next-line no-console
                      console.log("Retrive user");
                      this.$store.dispatch("user/login", user);
                      this.$router.push({ name: "projects" });
                    })
                    .catch(err => {
                      // eslint-disable-next-line no-console
                      console.log(
                        "Credenciales incorrectas limpiando los text fields.."
                      );
                      // eslint-disable-next-line no-console
                      console.log("Error" + err.message);
                    });
                } else {
                  this.orcidUser = user;
                  this.dialogPwd = true;
                }
              } else {
                // eslint-disable-next-line no-console
                console.log(
                  "Hay más de dos cuentas con el mismo orcidID, borrar una de la base de datos para que funcione correctamente"
                );
              }
            });
        })
        .catch(error => {
          // eslint-disable-next-line no-console
          console.log(error);
        });
    }
  },

  methods: {
    create_account() {
      this.$router.push({ name: "account" });
    },

    recover() {
      // eslint-disable-next-line no-console
      console.log("Recuperando la informacion del usuario..");

      firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(() => {
          this.snackbar = true;
          this.dialog = false;
        })
        // eslint-disable-next-line handle-callback-err
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          // eslint-disable-next-line no-console
          console.log("Error al recuperar la contrasena del usuario");
        });
    },

    auth_login: function() {
      // eslint-disable-next-line no-console
      console.log("Ingresando datos del usuario: ");

      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(user => {
          // eslint-disable-next-line no-console
          console.log("Retrive user");
          this.$store.dispatch("user/login", user);
          this.$router.push({ name: "projects" });
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log("Credenciales incorrectas limpiando los text fields..");
          this.alert = true;
          this.email = "";
          this.password = "";
          // eslint-disable-next-line no-console
          console.log("Error" + err.message);
        });
    },

    google_login() {
      // eslint-disable-next-line no-console
      console.log("Iniciando sesion con Google..");

      var provider = new firebase.auth.GoogleAuthProvider();

      provider.addScope("profile");
      provider.addScope("email");
      firebase
        .auth()
        .signInWithPopup(provider)
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          // This gives you a Google Access Token. You can use it to access the Google API.
          var token = result.credential.accessToken;

          // The signed-in user info.
          var user = result.user;

          // eslint-disable-next-line no-console
          console.log("Token:" + token);

          // eslint-disable-next-line no-console
          console.log("User: " + JSON.stringify(user));

          this.$store.dispatch("user/loginGoogle", user);

          // eslint-disable-next-line no-console
          console.log("Aquí");

          this.$router.push({ name: "projects" });
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log("Error iniciando sesion con Google.." + err.message);
        });
    },

    orcid_login() {
      window.location.href =
        "https://orcid.org/oauth/authorize?client_id=APP-6T2U5INEDICQNRFN&response_type=code&scope=/authenticate&redirect_uri=" +
        orcidRedirectUri +
        "/login";
    },

    logWithORCID() {
      const CryptoJS = require("crypto-js");
      const hash = CryptoJS.SHA3("participainteligente").toString();
      const encrypted = CryptoJS.AES.encrypt(this.providedPassword, hash).toString();
      // eslint-disable-next-line no-console
      console.log("Encrypted: " + encrypted);
      localStorage.setItem("pswd", encrypted);
      firebase
        .auth()
        .signInWithEmailAndPassword(
          this.orcidUser.email.primary,
          this.providedPassword
        )
        .then(user => {
          this.messageUser = "Redirigiendo...";
          this.snackbarUser = true;
          // eslint-disable-next-line no-console
          console.log("Retrive user");
          this.$store.dispatch("user/login", user);
          this.$router.push({ name: "projects" });
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log("Credenciales incorrectas limpiando los text fields..");
          // eslint-disable-next-line no-console
          console.log("Error" + err.message);
        });
    }
  }
};
</script>
<style>
.center {
  text-align: center;
}
</style>
